import {ErrorHandler, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DecimalPipe} from '@angular/common';
import {GoogleMapsValidationModel} from './google-maps-validation.model';
import { environment } from '../../environments/environment';

@Injectable()
export class AddressValidationService {
  constructor(private _http: HttpClient,
              private _decimalPipe: DecimalPipe,
              private _errorHandler: ErrorHandler) {}

  async checkAddress(requestBody: GoogleMapsValidationModel.RequestBody): Promise<GoogleMapsValidationModel.ResponseBody> {
    const GOOGLE_URL = `https://addressvalidation.googleapis.com/v1:validateAddress?key=${environment.googleApiKey}`;
    return this._http
      .post<GoogleMapsValidationModel.ResponseBody>(GOOGLE_URL, requestBody)
      .toPromise();
  }
}
